"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _BigButton = require("./BigButton.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BigButton = function BigButton(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      name = _ref.name,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover;
  var bigButtonConfig = config || _hotspot.bigButton;
  var hoverStyle = bigButtonConfig.hoverStyle;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_BigButton.ClickableAreaStyled, {
    hoverStyle: hoverStyle,
    onClick: onClick,
    previewHoverState: previewHoverState,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, iconPosition && _react.default.createElement(_BigButton.BigButtonStyled, {
    config: bigButtonConfig,
    iconPosition: iconPosition
  }, _react.default.createElement(_BigButton.BigButtonText, {
    config: bigButtonConfig
  }, name)));
};

var _default = BigButton;
exports.default = _default;